<template>
  <div
    v-if="showModal"
    class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-50"
  >
    <!-- Overlay -->
    <div
      class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
    ></div>

    <!-- Modal Container -->
    <div
      class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto"
    >
      <!-- Modal Content -->
      <div class="modal-content text-left">
        <!-- Title -->
        <div class="flex justify-between items-center bg-red-700 p-4">
          <p class="text-2xl font-bold text-white">{{ title }}</p>
          <div class="modal-close cursor-pointer z-50" @click="onContinue">
            <svg
              class="fill-current text-white"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              />
            </svg>
          </div>
        </div>

        <!-- Body -->
        <div class="p-4">
          <p>{{ message }}</p>
        </div>

        <!-- Footer -->
        <div class="flex flex-col gap-2 p-4">
          <button
            class="w-full button py-2 bg-blue-800 text-white hover:bg-blue-700"
            @click="onSave"
          >
            {{ $t("bodyprint_edit.dialogs.return.save") }}
          </button>
          <button
            class="w-full button py-2 bg-red-700 text-white hover:bg-red-600"
            @click="onCancel"
          >
            {{ $t("bodyprint_edit.dialogs.return.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReturnBodyprintModal",
  props: {
    showModal: {
      type: Boolean
    },
    title: {
      type: String
    },
    message: {
      type: String
    },
    onContinue: {
      type: Function
    },
    onSave: {
      type: Function
    },
    onCancel: {
      type: Function
    }
  }
};
</script>
